// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ClipboardListIcon } from '@moia-dev/pace-icons'
import { useTranslation } from 'react-i18next'
import { SafetyDriverAnnotationsAreaRoutes } from './SafetyDriverAnnotationsAreaRoutes'

// TODO: add your NavigationItem to the main menu
// check docs/how-tos/add-a-new-library.md for more info

// TODO: Replace icon with your actual area icon
export const SafetyDriverAnnotationsAreaNavigationIcon = ClipboardListIcon

export const SafetyDriverAnnotationsAreaNavigation = ({
  onClick,
  open,
}: AreaNavigationProps) => {
  const { t } = useTranslation()
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={t('safetyDriverAnnotation_navigation_label')}
      to={SafetyDriverAnnotationsAreaRoutes.route}
      Icon={ClipboardListIcon}
    />
  )
}
